/**
 * The two cash-flow dialogs' registry ids, on their own.
 *
 * They sat beside the dialogs themselves, which is fine for the sidebar that
 * only wants to open one — but the flows INSIDE those dialogs need to name
 * them too, to stand their own dialog down while a one-time-code step is up.
 * Importing them from the module that imports the flows would be a cycle, and
 * these are two strings.
 */
export const DEPOSIT_CASH_MODAL = "deposit-cash";
export const WITHDRAW_CASH_MODAL = "withdraw-cash";
